export default __webpack_public_path__ + "static/media/bannerBG-dark.48d865ac.jpg";